function normalizeList (value) {
  if (value === undefined || value === null) return []
  return Array.isArray(value) ? value : [value]
}

function hasValue (value) {
  return value !== undefined && value !== null && value !== ''
}

function normalizeValue (value) {
  return hasValue(value) ? String(value).trim() : ''
}

function questionMatchesSelector (question, selector) {
  if (!question || !selector || question.show === false) return false

  const section = question.section || {}
  if (
    selector.sectionNumbers &&
    !selector.sectionNumbers.includes(section.number)
  ) {
    return false
  }

  if (selector.sectionNumber && selector.sectionNumber !== section.number) {
    return false
  }

  if (selector.type && selector.type !== question.type) {
    return false
  }

  if (selector.identifier && selector.identifier !== question.identifier) {
    return false
  }

  return true
}

function getQuestionsMatchingSelector (questions, selector) {
  return (questions || []).filter((question) =>
    questionMatchesSelector(question, selector)
  )
}

function getValuesAtPath (source, path) {
  const pathParts = String(path || 'answer')
    .split('.')
    .filter(Boolean)

  function collect (value, remainingPath) {
    if (Array.isArray(value)) {
      return value.reduce(
        (values, item) =>
          item &&
          typeof item === 'object' &&
          item.hiddenByDisabilityExtremity === true
            ? values
            : values.concat(collect(item, remainingPath)),
        []
      )
    }

    if (remainingPath.length === 0) {
      return [value]
    }

    if (value === undefined || value === null) {
      return [undefined]
    }

    const [key, ...rest] = remainingPath
    return collect(value[key], rest)
  }

  return collect(source, pathParts)
}

function getConfiguredValues (questions, config) {
  return getQuestionsMatchingSelector(questions, config.selector).reduce(
    (values, question) =>
      values.concat(getValuesAtPath(question, config.valuePath)),
    []
  )
}

function isLastValidationQuestion (questions, currentQuestion, selector) {
  const matchingQuestions = getQuestionsMatchingSelector(questions, selector)
  return (
    matchingQuestions.length > 0 &&
    matchingQuestions[matchingQuestions.length - 1] === currentQuestion
  )
}

function sourceAnyDiffersAndTargetAllEqual (questions, config) {
  const sourceValues = getConfiguredValues(questions, config.source)
    .map(normalizeValue)
    .filter(Boolean)
  const targetValues = getConfiguredValues(questions, config.target).map(
    normalizeValue
  )

  if (sourceValues.length === 0 || targetValues.length === 0) {
    return false
  }

  const sourceAnswer = normalizeValue(config.rule.sourceAnswer)
  const targetAnswer = normalizeValue(config.rule.targetAnswer)
  const sourceConditionMet = sourceValues.some(
    (value) => value !== sourceAnswer
  )
  const targetConditionMet =
    targetValues.every(Boolean) &&
    targetValues.every((value) => value === targetAnswer)

  return sourceConditionMet && targetConditionMet
}

function ruleMatches (questions, config) {
  if (config.rule.type === 'sourceAnyDiffersAndTargetAllEqual') {
    return sourceAnyDiffersAndTargetAllEqual(questions, config)
  }

  return false
}

export function validateCrossQuestionValues (questions, currentQuestion) {
  const validations = normalizeList(
    currentQuestion && currentQuestion.crossQuestionValueValidation
  )

  for (const config of validations) {
    if (
      !config ||
      !config.validateOnLastMatchingQuestion ||
      !config.source ||
      !config.target ||
      !config.rule ||
      !isLastValidationQuestion(
        questions,
        currentQuestion,
        config.validateOnLastMatchingQuestion
      )
    ) {
      continue
    }

    if (ruleMatches(questions, config)) {
      return { message: config.message }
    }
  }

  return null
}
